
import { useEffect } from 'react';
export function Header() {
return (
    <div className="component-header">
    <div className="logo">
      <img src="/image/logo.png" alt="" />
    </div>
  </div>
)
}